export default 'USER_REQUESTED_NEW_RECORDING';
